import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarSimpleLeftWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSidebarSimpleLeftWide"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 4C3.11929 4 2 5.11929 2 6.5V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V6.5C22 5.11929 20.8807 4 19.5 4H4.5ZM8 5V19H19.5C20.3284 19 21 18.3284 21 17.5V6.5C21 5.67157 20.3284 5 19.5 5H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleLeftWide;
